import { render, staticRenderFns } from "./restrict-chip.vue?vue&type=template&id=7f1a3a78&"
import script from "./restrict-chip.vue?vue&type=script&lang=js&"
export * from "./restrict-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports